// /components/simulator/ExecSummaryRouter.jsx

import React from 'react';

// Import each model's specific summary
import TraditionalRentalExecSummary from './summaries/TraditionalRentalExecSummary';
import BankLendingExecSummary from './summaries/BankLendingExecSummary';
import RentToOwnExecSummary from './summaries/RentToOwnExecSummary';
import RentToOwnGoldExecSummary from './summaries/RentToOwnGoldExecSummary';
import RentToOwnRealEstateExecSummary from './summaries/RentToOwnRealEstateExecSummary';
import RentToOwnBusinessExecSummary from './summaries/RentToOwnBusinessExecSummary';
import RentToOwnStockExecSummary from './summaries/RentToOwnStockExecSummary';
import GoldInvestmentExecSummary from './summaries/GoldInvestmentExecSummary';
import StockInvestmentExecSummary from './summaries/StockInvestmentExecSummary';
import BusinessInvestmentExecSummary from './summaries/BusinessInvestmentExecSummary';

const ExecSummaryRouter = ({ modelName, investorResult, borrowerResult, yearlyData, params }) => {
  switch (modelName) {
    case 'Traditional Rental':
      return (
        <TraditionalRentalExecSummary
          investorResult={investorResult}
          borrowerResult={borrowerResult}
          yearlyData={yearlyData}
          params={params}
        />
      );
    case 'Bank Lending':
      return (
        <BankLendingExecSummary
          investorResult={investorResult}
          borrowerResult={borrowerResult}
          yearlyData={yearlyData}
          params={params}
        />
      );
    case 'Rent-to-Own':
      return (
        <RentToOwnExecSummary
          investorResult={investorResult}
          borrowerResult={borrowerResult}
          yearlyData={yearlyData}
          params={params}
        />
      );
    case 'Rent-to-Own + Gold':
      return (
        <RentToOwnGoldExecSummary
          investorResult={investorResult}
          borrowerResult={borrowerResult}
          yearlyData={yearlyData}
          params={params}
        />
      );
    case 'Rent-to-Own + Real Estate':
      return (
        <RentToOwnRealEstateExecSummary
          investorResult={investorResult}
          borrowerResult={borrowerResult}
          yearlyData={yearlyData}
          params={params}
        />
      );
    // case 'Rent-to-Own + Business':
    //   return (
    //     <RentToOwnBusinessExecSummary
    //       investorResult={investorResult}
    //       borrowerResult={borrowerResult}
    //       yearlyData={yearlyData}
    //       params={params}
    //     />
    //   );
    case 'Rent-to-Own + Stock':
      return (
        <RentToOwnStockExecSummary
          investorResult={investorResult}
          borrowerResult={borrowerResult}
          yearlyData={yearlyData}
          params={params}
        />
      );
    case 'Gold Investment':
      return (
        <GoldInvestmentExecSummary
          investorResult={investorResult}
          borrowerResult={borrowerResult}
          yearlyData={yearlyData}
          params={params}
        />
      );
    case 'Stock Investment':
      return (
        <StockInvestmentExecSummary
          investorResult={investorResult}
          borrowerResult={borrowerResult}
          yearlyData={yearlyData}
          params={params}
        />
      );
    // case 'Business Investment':
    //   return (
    //     <BusinessInvestmentExecSummary
    //       investorResult={investorResult}
    //       borrowerResult={borrowerResult}
    //       yearlyData={yearlyData}
    //       params={params}
    //     />
    //   );
    default:
      return (
        <div className="text-red-500 font-semibold p-4">
          No Executive Summary available for {modelName}
        </div>
      );
  }
};

export default ExecSummaryRouter;
